import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const Toppings = () => {
    const [toppings, setToppings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [globalPrice, setGlobalPrice] = useState('0.50');
    const [updatingGlobal, setUpdatingGlobal] = useState(false);
    
    const [formData, setFormData] = useState({
        id: null,
        name: '',
        price: '0.50',
        is_active: true
    });

    useEffect(() => {
        fetchToppings();
    }, []);

    const fetchToppings = async () => {
        try {
            setLoading(true);
            const response = await api.get('/api/menu/toppings/');
            const data = response.data.results || response.data;
            setToppings(Array.isArray(data) ? data : []);
            setError(null);
        } catch (err) {
            console.error('Error fetching toppings:', err);
            setError('Error al cargar los toppings');
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleApplyGlobalPrice = async () => {
        const p = parseFloat(globalPrice);
        if (isNaN(p) || p < 0) {
            alert('Por favor ingrese un valor de precio válido (ej: 0.50)');
            return;
        }
        try {
            setUpdatingGlobal(true);
            await api.post('/api/menu/toppings/bulk-price/', { price: p });
            alert(`✅ ¡Precio de adicionales actualizado a $${p.toFixed(2)} para todos los toppings!`);
            fetchToppings();
        } catch (err) {
            console.error('Error updating bulk topping price:', err);
            alert('Error al actualizar el precio general de toppings');
        } finally {
            setUpdatingGlobal(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                name: formData.name.trim(),
                price: parseFloat(formData.price) || 0.50,
                is_active: formData.is_active
            };
            if (formData.id) {
                await api.put(`/api/menu/toppings/${formData.id}/`, payload);
            } else {
                await api.post('/api/menu/toppings/', payload);
            }
            setShowModal(false);
            fetchToppings();
            resetForm();
        } catch (err) {
            console.error('Error saving topping:', err);
            alert('Error al guardar el topping');
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('¿Está seguro de eliminar este topping?')) {
            try {
                await api.delete(`/api/menu/toppings/${id}/`);
                fetchToppings();
            } catch (err) {
                console.error('Error deleting topping:', err);
                alert('Error al eliminar el topping');
            }
        }
    };

    const editTopping = (topping) => {
        setFormData({
            id: topping.id,
            name: topping.name,
            price: topping.price !== undefined && topping.price !== null ? topping.price : '0.50',
            is_active: topping.is_active
        });
        setShowModal(true);
    };

    const resetForm = () => {
        setFormData({
            id: null,
            name: '',
            price: globalPrice || '0.50',
            is_active: true
        });
    };

    if (loading) return <div style={{ padding: '2rem' }}>Cargando toppings...</div>;
    if (error) return <div style={{ padding: '2rem', color: 'red' }}>{error}</div>;

    return (
        <div style={{ padding: '2rem', maxWidth: '950px', margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
                <div>
                    <h2 style={{ margin: 0, color: 'var(--primary-color)', fontSize: '1.75rem', fontWeight: 'bold' }}>
                        🍨 Gestión de Toppings & Adicionales
                    </h2>
                    <p style={{ margin: '0.25rem 0 0 0', color: '#6b7280', fontSize: '0.9rem' }}>
                        Configura los toppings disponibles y el valor cobrado cuando se solicitan como adicionales.
                    </p>
                </div>
                <button 
                    onClick={() => { resetForm(); setShowModal(true); }}
                    style={{
                        padding: '0.75rem 1.5rem',
                        backgroundColor: 'var(--primary-color)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
                    }}
                >
                    <i className="bi bi-plus-circle-fill"></i> Nuevo Topping
                </button>
            </div>

            {/* APARTADO DE CONFIGURACIÓN DEL VALOR ADICIONAL */}
            <div style={{
                backgroundColor: '#f0fdf4',
                border: '1px solid #bbf7d0',
                borderRadius: '12px',
                padding: '1.25rem 1.5rem',
                marginBottom: '1.75rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.03)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ fontSize: '2.25rem' }}>💰</div>
                    <div>
                        <h4 style={{ margin: 0, color: '#166534', fontSize: '1.05rem', fontWeight: 'bold' }}>
                            Valor por Topping Adicional
                        </h4>
                        <p style={{ margin: '0.2rem 0 0 0', color: '#15803d', fontSize: '0.85rem' }}>
                            Establece el precio que se sumará al total cuando el cliente elija un topping extra en el Punto de Venta.
                        </p>
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#fff', border: '2px solid #86efac', borderRadius: '8px', padding: '0.4rem 0.75rem' }}>
                        <span style={{ fontWeight: 'bold', color: '#166534', fontSize: '1.1rem', marginRight: '0.25rem' }}>$</span>
                        <input
                            type="number"
                            step="0.01"
                            min="0"
                            value={globalPrice}
                            onChange={(e) => setGlobalPrice(e.target.value)}
                            style={{
                                width: '75px',
                                border: 'none',
                                outline: 'none',
                                fontSize: '1.1rem',
                                fontWeight: 'bold',
                                color: '#166534'
                            }}
                            placeholder="0.50"
                        />
                    </div>
                    <button
                        type="button"
                        onClick={handleApplyGlobalPrice}
                        disabled={updatingGlobal}
                        style={{
                            padding: '0.6rem 1.25rem',
                            backgroundColor: '#16a34a',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            fontWeight: 'bold',
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.4rem',
                            boxShadow: '0 2px 4px rgba(22, 163, 74, 0.2)'
                        }}
                    >
                        <i className="bi bi-check-all"></i> {updatingGlobal ? 'Guardando...' : 'Aplicar a Todos'}
                    </button>
                </div>
            </div>

            <div style={{ backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', overflow: 'hidden', border: '1px solid #e5e7eb' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                            <th style={{ padding: '1rem', textAlign: 'left', color: '#374151', fontWeight: '600' }}>Topping / Ingrediente</th>
                            <th style={{ padding: '1rem', textAlign: 'center', color: '#374151', fontWeight: '600' }}>Precio Adicional</th>
                            <th style={{ padding: '1rem', textAlign: 'center', color: '#374151', fontWeight: '600' }}>Estado</th>
                            <th style={{ padding: '1rem', textAlign: 'right', color: '#374151', fontWeight: '600' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {toppings.map(topping => {
                            const priceVal = parseFloat(topping.price !== undefined && topping.price !== null ? topping.price : 0.50);
                            return (
                                <tr key={topping.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                    <td style={{ padding: '1rem', fontWeight: '600', color: '#111827' }}>
                                        <span style={{ marginRight: '6px' }}>🍨</span>
                                        {topping.name}
                                    </td>
                                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                                        <span style={{
                                            padding: '0.25rem 0.65rem',
                                            borderRadius: '6px',
                                            fontSize: '0.875rem',
                                            fontWeight: 'bold',
                                            backgroundColor: '#ecfdf5',
                                            color: '#047857',
                                            border: '1px solid #a7f3d0'
                                        }}>
                                            +${priceVal.toFixed(2)}
                                        </span>
                                    </td>
                                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                                        <span style={{ 
                                            padding: '0.25rem 0.75rem', 
                                            borderRadius: '9999px', 
                                            fontSize: '0.75rem', 
                                            fontWeight: 'bold',
                                            backgroundColor: topping.is_active ? '#d1fae5' : '#fee2e2',
                                            color: topping.is_active ? '#065f46' : '#991b1b'
                                        }}>
                                            {topping.is_active ? 'Activo' : 'Inactivo'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '1rem', textAlign: 'right' }}>
                                        <button 
                                            onClick={() => editTopping(topping)}
                                            title="Editar topping"
                                            style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', marginRight: '0.75rem', fontSize: '1.15rem' }}
                                        >
                                            <i className="bi bi-pencil-square"></i>
                                        </button>
                                        <button 
                                            onClick={() => handleDelete(topping.id)}
                                            title="Eliminar topping"
                                            style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '1.15rem' }}
                                        >
                                            <i className="bi bi-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                        {toppings.length === 0 && (
                            <tr>
                                <td colSpan="4" style={{ padding: '3rem', textAlign: 'center', color: '#6b7280' }}>
                                    No hay toppings creados. Haz clic en <strong>"Nuevo Topping"</strong> para añadir uno.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal */}
            {showModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '1rem'
                }}>
                    <div style={{
                        backgroundColor: '#fff', borderRadius: '16px', padding: '2rem',
                        width: '100%', maxWidth: '440px', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)'
                    }}>
                        <h3 style={{ marginTop: 0, marginBottom: '1.5rem', color: '#111827', fontSize: '1.25rem', fontWeight: 'bold' }}>
                            {formData.id ? '✏️ Editar Topping' : '➕ Nuevo Topping'}
                        </h3>
                        <form onSubmit={handleSubmit}>
                            <div style={{ marginBottom: '1rem' }}>
                                <label style={{ display: 'block', marginBottom: '0.4rem', color: '#374151', fontWeight: '600', fontSize: '0.9rem' }}>
                                    Nombre del Topping
                                </label>
                                <input 
                                    type="text" 
                                    name="name" 
                                    value={formData.name} 
                                    onChange={handleInputChange}
                                    placeholder="Ej: Oreo, Leche Condensada, Maní"
                                    required
                                    style={{
                                        width: '100%', padding: '0.75rem', borderRadius: '8px',
                                        border: '1px solid #d1d5db', outline: 'none', fontSize: '0.95rem'
                                    }}
                                />
                            </div>

                            <div style={{ marginBottom: '1.25rem' }}>
                                <label style={{ display: 'block', marginBottom: '0.4rem', color: '#374151', fontWeight: '600', fontSize: '0.9rem' }}>
                                    Precio si se elige como Adicional ($)
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #d1d5db', borderRadius: '8px', padding: '0 0.75rem', backgroundColor: '#f9fafb' }}>
                                    <span style={{ fontWeight: 'bold', color: '#6b7280', marginRight: '0.25rem' }}>$</span>
                                    <input 
                                        type="number" 
                                        step="0.01" 
                                        min="0"
                                        name="price" 
                                        value={formData.price} 
                                        onChange={handleInputChange}
                                        placeholder="0.50"
                                        required
                                        style={{
                                            width: '100%', padding: '0.75rem 0.25rem',
                                            border: 'none', background: 'transparent', outline: 'none', fontSize: '0.95rem', fontWeight: 'bold'
                                        }}
                                    />
                                </div>
                                <span style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.25rem', display: 'block' }}>
                                    Valor que se cobrará por este topping cuando exceda el límite del producto.
                                </span>
                            </div>

                            <div style={{ marginBottom: '1.5rem' }}>
                                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <input 
                                        type="checkbox" 
                                        name="is_active" 
                                        checked={formData.is_active} 
                                        onChange={handleInputChange}
                                        style={{ marginRight: '0.5rem', width: '1.15rem', height: '1.15rem', accentColor: 'var(--primary-color)' }}
                                    />
                                    <span style={{ color: '#374151', fontWeight: '500', fontSize: '0.9rem' }}>Topping Activo</span>
                                </label>
                            </div>

                            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
                                <button 
                                    type="button" 
                                    onClick={() => setShowModal(false)}
                                    style={{
                                        padding: '0.65rem 1.25rem', backgroundColor: '#f3f4f6',
                                        color: '#374151', border: '1px solid #d1d5db', borderRadius: '8px', cursor: 'pointer', fontWeight: '600'
                                    }}
                                >
                                    Cancelar
                                </button>
                                <button 
                                    type="submit"
                                    style={{
                                        padding: '0.65rem 1.5rem', backgroundColor: 'var(--primary-color)',
                                        color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold'
                                    }}
                                >
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Toppings;
